module.exports = __webpack_public_path__ + "aa19bc22783454ad9da32c2f6de524b5.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/810.png
// module id = 1713
// module chunks = 2